// extracted by mini-css-extract-plugin
export default {"navbar-nav":"styles_navbar-nav__h44Ut","nav-link":"styles_nav-link__Ytbk8","dropdown-toggle":"styles_dropdown-toggle__alNck","App":"styles_App__yjk7s"};